export const RegularEnvironment = {
  production: false,
  baseUrl: 'https://localhost/NIASBiz.API/',
  niasRedirectUrl: 'http://localhost:4200/nias-auth',
  niasRedirectErrorUrl: 'http://localhost:4200/nias-error',
  niasLogoutUrl: 'http://localhost:4200/nias-logout',
};
